import type { PayloadAction } from '@reduxjs/toolkit';
import type { MedNecCaseSliceState } from '../state';
import type { MedNecCaseView, PatientView } from '../../types/medNecTypes';
import { createEmptyCase } from '../../types/medNecTypes';

export const draftReducers = {
  initDraft: (state: MedNecCaseSliceState, action: PayloadAction<string>) => {
    state.draftCase = createEmptyCase({ facilityCode: action.payload });
  },

  updateDraft: (state: MedNecCaseSliceState, action: PayloadAction<Partial<MedNecCaseView>>) => {
    if (state.draftCase) {
      Object.assign(state.draftCase, action.payload);
    }
  },

  updateDraftPatient: (
    state: MedNecCaseSliceState,
    action: PayloadAction<Partial<PatientView>>,
  ) => {
    if (state.draftCase?.patient) {
      Object.assign(state.draftCase.patient, action.payload);
    }
  },

  clearDraft: (state: MedNecCaseSliceState) => {
    state.draftCase = null;
  },
};
